(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7054],{

/***/ 75915:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services",
      function () {
        return __webpack_require__(27921);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 27921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ services; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/prismic-reactjs/dist/prismic-reactjs.js
var prismic_reactjs = __webpack_require__(75833);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/sections/Hero/index.ts + 2 modules
var Hero = __webpack_require__(5650);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
;// CONCATENATED MODULE: ./styles/pages/styled/services/services.styles.tsx

const Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1sii5y0"
})("background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";");

// EXTERNAL MODULE: ./components/sections/SectionDescriptionWithImage/index.ts + 2 modules
var SectionDescriptionWithImage = __webpack_require__(21488);
// EXTERNAL MODULE: ./models/enums/titleAs.ts
var titleAs = __webpack_require__(79794);
;// CONCATENATED MODULE: ./pages/services/index.tsx








const DynamicServicesComponent = dynamic_default()(()=>__webpack_require__.e(/* import() */ 5046).then(__webpack_require__.bind(__webpack_require__, 15046)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(15046)
            ]
    }
});
const DynamicOurTechStack = dynamic_default()(()=>__webpack_require__.e(/* import() */ 8179).then(__webpack_require__.bind(__webpack_require__, 48179)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(48179)
            ]
    }
});
const DynamicWhyUs = dynamic_default()(()=>__webpack_require__.e(/* import() */ 3198).then(__webpack_require__.bind(__webpack_require__, 43198)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(43198)
            ]
    }
});
const Services = (param)=>{
    let { data: { page  }  } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero/* default */.Z, {
                title: prismic_reactjs.RichText.asText(page.title),
                lottieProps: {
                    id: "services_hero_lottie",
                    src: "https://assets2.lottiefiles.com/packages/lf20_yhek11ra.json"
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionDescriptionWithImage/* default */.Z, {
                title: prismic_reactjs.RichText.asText(page.partner_team.title),
                subtitle: prismic_reactjs.RichText.asText(page.partner_team.subtitle),
                description: prismic_reactjs.RichText.asText(page.partner_team.description),
                image: page.partner_team.image,
                isImageToRight: true,
                titleAs: titleAs/* TitleAs.h2 */.P.h2
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DynamicServicesComponent, {
                services: page.services
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DynamicOurTechStack, {
                title: prismic_reactjs.RichText.asText(page.our_tech_stack.title),
                description: prismic_reactjs.RichText.asText(page.our_tech_stack.description),
                ourTechStackIcons: page.our_tech_stack.icons,
                whatWeCanDoValues: page.our_tech_stack.what_we_can_do_list,
                whatWeCanDoTitle: prismic_reactjs.RichText.asText(page.our_tech_stack.what_we_can_do_title),
                titleAs: titleAs/* TitleAs.h4 */.P.h4
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DynamicWhyUs, {
                title: prismic_reactjs.RichText.asText(page.why_us_title),
                reasons: page.why_us_reasons.map((reason)=>({
                        title: prismic_reactjs.RichText.asText(reason.reason_title),
                        description: prismic_reactjs.RichText.asText(reason.reason_description),
                        image: reason.reason_image
                    })),
                titleAs: titleAs/* TitleAs.h5 */.P.h5
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var services = (Services);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1352,9774,2888,179], function() { return __webpack_exec__(75915); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);